import React, { Fragment } from 'react';

import {
  Dialog,
  Transition,
} from '@headlessui/react';

import SolidSpinnerIcon from '../assets/icons/SolidSpinnerIcon';

const AlertOverlay = ({
  loading = false,
  onClick,
  description,
  title,
  isOpen,
  setIsOpen,
  primaryActionTitle,
  secondaryActionTitle
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center bg-black/20 ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-zinc-800 border border-zinc-700 p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-zinc-200"
                >
                  {title}
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-zinc-300">{description}</p>
                </div>

                <div className="mt-4 flex gap-4 justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center bg-zinc-700 rounded-md border border-zinc-600 text-zinc-200 px-4 py-2 text-sm font-medium  hover:bg-zinc-600 duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={() => setIsOpen(false)}
                  >
                    {primaryActionTitle}
                  </button>
                  <button
                    type="button"
                    className="inline-flex justify-center items-center gap-1 rounded-md border border-transparent bg-red-500 px-4 py-2 text-sm font-medium text-white duration-300 hover:bg-red-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={onClick}
                  >
                    {loading ? (
                      <SolidSpinnerIcon className="w-4 h-4  animate-spin" />
                    ) : null}
                    <span>{secondaryActionTitle}</span>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AlertOverlay;
